module.exports = __webpack_public_path__ + "img/no hair in front of face.8ace9491.png";